<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item v-show="false" label="组编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'groupNo', validatorRules.groupNo]" placeholder="请输入组编号"></a-input>
        </a-form-item>
        <a-form-item v-show="false" label="基地名" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'base', validatorRules.base]" placeholder="请输入基地名"></a-input>
        </a-form-item>
        <a-form-item label="基地" :labelCol="labelCol" :wrapperCol="wrapperCol">
           <j-dict-select-tag ref="baseNoTagRef"  v-decorator="[ 'baseNo', validatorRules.baseNo]" :triggerChange="true"  placeholder="请选择基地"   dictCode="bus_inspection_general_base,base,base_no,status = '1'"  ></j-dict-select-tag>
        </a-form-item>
        <a-form-item label="组名" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'groupName', validatorRules.groupName]" placeholder="请输入组名"></a-input>
        </a-form-item>
        <a-form-item label="是否启用" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag v-decorator="[ 'status', validatorRules.status]" :triggerChange="true" placeholder="请选择是否启用"   dictCode="on_off"   ></j-dict-select-tag>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'

  export default {
    name: "BusInspectionGroupModal",
    components: { 
    },
    data () {
      return {
        form: this.$form.createForm(this,{onValuesChange:this.handleBaseChange}),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          delFlag: {rules: [
          ]},
          groupNo: {rules: [
          ]},
          groupName: {rules: [
          ]},
          status: {rules: [
          ]},
          baseNo: {rules: [
          ]},
          base: {rules: [
          ]},
        },
        url: {
          add: "/general/group/busInspectionGroup/add",
          edit: "/general/group/busInspectionGroup/edit",
        }
      }
    },
    created () {
    },
    methods: {
      add (record) {
        this.edit(record);
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'delFlag','groupNo','groupName','status','baseNo','base'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'delFlag','groupNo','groupName','status','baseNo','base'))
      },
      handleBaseChange(props,value){
        console.log(value)
        if(value.baseNo){
          let dictOptions=this.$refs.baseNoTagRef.getCurrentDictOptions();
          let base=""
          console.log(dictOptions)
          if(dictOptions.length==0){
            return
          }
          dictOptions.some((item)=>{
            if(item.value==value.baseNo){
              base=item.text || item.label
            }
          })
          this.form.setFieldsValue({
            base
          })
        }
      }
    }
  }
</script>